import { GET_BY_ID_LIST } from '@inpart-io/devtools-vue';
import { type IEvaluationComment } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { GET_SEARCH_RESULT_ID_LIST_BY_KEY } from '@/store/base/search/getters';

export const GET_ALL_CREATORS = 'getAllCreators';

export const getters: GetterTree<IEvaluationComment, unknown> = {
    [GET_ALL_CREATORS]: (_state, _getters, _rootState, _rootGetters) => {
        return (key: number): number[] | null => {
            const idList = _getters[GET_SEARCH_RESULT_ID_LIST_BY_KEY](key);

            if (idList === null) {
                return null;
            } else {
                const dataObjectList: IEvaluationComment[] = _getters[GET_BY_ID_LIST](idList);
                const participants = [] as number[];
                if (dataObjectList?.length > 0) {
                    dataObjectList.forEach((comment) => {
                        participants.push(comment.createdBy as number);
                    });
                }
                return participants;
            }
        };
    }
};
